const propelInit = function() {
const MOBILE_BREAKPOINT = 992;

const loadScripts = (scripts) => {
	scripts.forEach(({ src }) => {
		if (document.querySelector(`script[src="${src}"]`)) {
			return;
		}

		const script = document.createElement('script');

		script.src = src;
		script.async = false;
		document.head.appendChild(script);
	});
};

const maybeLoadBackgroundVideo = () => {
	if (window.innerWidth < MOBILE_BREAKPOINT) {
		return false;
	}

	const scripts = window.propelLazyBackgroundVideo?.scripts;

	if (scripts?.length) {
		loadScripts(scripts);
	}

	return true;
};

if (!maybeLoadBackgroundVideo()) {
	window.addEventListener('resize', function onResize() {
		if (maybeLoadBackgroundVideo()) {
			window.removeEventListener('resize', onResize);
		}
	});
}

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['background-video-loader'] = window.propel.blocks['background-video-loader'] || {};
window.propel.blocks['background-video-loader'].script = propelInit;
